import React from "react";

class Title extends React.Component {
    render() {
        return (
            <div className="TitleMain">
                <h1 className="TitleText">Калькулятор молекулярних мас<span className="VersionText">v2.0</span></h1>
                <h2 className="SubTitle">Зробив Соломка Борис</h2>
            </div>
        )
    }
}

export default Title